module.exports = __webpack_public_path__ + "nc_static/media/file.b3db3f82.svg";